import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
function ReviewSection(props) {
    const { t, i18n } = useTranslation('common');
    const [review, setReview] = useState([]);
    const [ratings, setRatings] = useState([5, 4, 3, 2, 1]);


    useEffect(() => {
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
      setReview(props?.ratingavgdata);
          
    }, [])

    function get_average_total_review(data) {
        return Number((parseFloat(data?.category1) + parseFloat(data?.category2) + parseFloat(data?.category3) + parseFloat(data?.category4) + parseFloat(data?.category5)) / 5).toFixed(2)
    }

    return (<section class="review-section">
        <div class="container_size">
            <div class="review-category">
                <div class="star_rating_number">
                    <ul class="overall-rating_ul">
                        <li class="review-number overall-rating_list">
                            <div class="overall-rating_div">
                                <h4 class="overall-rating">{t('Overall rating')}</h4>
                                <h1>

                                    {(review[0]?.total_avg) ?
                                        Number(review[0]?.total_avg).toFixed(2)
                                        : '0'
                                    }
                                </h1>
                            </div>
                            <div class="review_star main_review">
                                <div class="review-form-star-rating">
                                {(review[0]?.total_avg) ?
                                    <div class="rem_Stars" style={{ '--rating': Number(review[0]?.total_avg).toFixed(2) }}>
                                    </div>
                                    : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                    </div>
                                }
                                </div>
                                <p>
                                    {(review[0]?.reviewer) ? review[0]?.reviewer + ' ' : 0 + ' '}
                                    {t('Reviews')}
                                </p>
                            </div>
                        </li>
                    </ul>
                    <ul class="mobile_hide">
                        <li class="review-number">
                            <div>
                                <a class="rem_solid_btn" href="#review_section">{t('Read more')} <br /> {t('Reviews')} </a>
                            </div>
                            <div class="review_star">
                            {(props?.lan == 'en') ?
                            <a class="rem_outline_btn" href={props?.site_url + '/en/review-section-1/?trader=' + props?.data?.ID}>{t("Leave your")} <br /> {t("own review")}</a>
                                
                          :  <a class="rem_outline_btn" href={props?.site_url + '/review-1/?trader=' + props?.data?.ID}>{t("Leave your")} <br /> {t("own review")}</a>
                            }
                                </div>
                        </li>
                    </ul>
                </div>
                <div class="all-review">
                    <ul>
                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Initial Impression')}</p>
                            
                                <div class="review-form-star-rating">
                                    <span class="ratingsStar">
                                        {(review[0]?.rating1) ?
                                            <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating1).toFixed(2) }}>
                                            </div>
                                            : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                            </div>
                                        }
                                    </span>
                                </div>
                            </div>
                        </li>

                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Punctuality')}</p>

                                <div class="review-form-star-rating">
                                    {(review[0]?.rating2) ?
                                        <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating2).toFixed(2) }}>
                                        </div>
                                        : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                        </div>
                                    }
                                </div>
                            </div>
                        </li>

                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Cleanliness')}</p>
                                <div class="review-form-star-rating">
                                    {(review[0]?.rating3) ?
                                        <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating3).toFixed(2) }}>
                                        </div>
                                        : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                        </div>
                                    }
                                </div>
                            </div>
                        </li>
                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Quality')}</p>
                                <div class="review-form-star-rating">
                                    <span class="ratingsStar">
                                        {(review[0]?.rating4) ?
                                            <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating4).toFixed(2) }}>
                                            </div>
                                            : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                            </div>
                                        }
                                    </span>
                                </div>
                            </div>
                        </li>

                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Value')}</p>
                                <div class="review-form-star-rating">
                                    {(review[0]?.rating5) ?
                                        <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating5).toFixed(2) }}>
                                        </div>
                                        : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                        </div>
                                    }
                                </div>
                            </div>
                        </li>

                        <li class="review-number">
                            <div class="review_star">
                                <p>{t('Overall rating')}</p>
                                <div class="review-form-star-rating">
                                    {(review[0]?.rating6) ?
                                        <div class="rem_Stars" style={{ '--rating': Number(review[0]?.rating6).toFixed(2) }}>
                                        </div>
                                        : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                        </div>
                                    }
                                </div>
                            </div>
                        </li>
                    </ul>

                    <ul class="mobile_show">
                        <li class="review-number">
                            <div>
                                <a class="rem_solid_btn" href="#review_section">{t('Read more')} <br /> {t('Reviews')}</a>
                            </div>
                            <div class="review_star">
                            {(props?.lan == 'en') ?
                            <a class="rem_outline_btn" href={props?.site_url +'/en/review-section-1/?trader=' + props?.data?.ID}>{t('Leave your')} <br /> {t('own review')}</a>
                            : <a class="rem_outline_btn" href={props?.site_url + '/review-1/?trader=' + props?.data?.ID}>{t('Leave your')} <br /> {t('own review')}</a>
}
                                </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>);
}

export default ReviewSection;